
export enum TrendsFilterEnum {
    EM_ALTA = "EM_ALTA",
    EM_BAIXA = "EM_BAIXA",
    MAIS_NEGOCIADAS = "MAIS_NEGOCIADAS",
    PODE_CAIR = "PODE_CAIR",
    PODE_SUBIR = "PODE_SUBIR"
}